module.exports = __webpack_public_path__ + "static/media/lidingshan.e5069b31.webp";